import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import LinuxSVG from '../../../assets/icons/clouds/linux.svg?raw';

export const LinuxLogo = (props) => <CustomSVG svg={LinuxSVG} preserveColors {...props} />;
